import { Service } from '@roc/feature-app-core';
import {
  BankStatementOtherSource,
  BankStatement,
} from '../stores/bankStatementsStore';

const url = {
  GET_BY_LOAN_AND_BORROWER: '/api/v1/loan/bankStatement/getBankStatementInfo',
  SAVE_BANK_STATEMENT: '/api/v1/loan/bankStatement/save',
  UPLOAD_BANK_STATEMENTS: '/api/v1/loan/bankStatement/upload',
  DOWNLOAD_BANK_STATEMENT: '/api/v1/loan/bankStatement/download',
  SAVE_OTHER_SOURCE:
    '/api/v1/loan/bankStatement/otherSource/save',
  DELETE_OTHER_SOURCE:
    '/api/v1/loan/bankStatement/otherSource/delete',
};

export class BankStatementsService extends Service {
  getBankStatementInfo(loanId: number, borrowerId: number) {
    return this.get(url.GET_BY_LOAN_AND_BORROWER, { loanId, borrowerId });
  }

  saveBankStatement(bankStatement: BankStatement) {
    return this.post(url.SAVE_BANK_STATEMENT, bankStatement);
  }

  uploadBankStatements(files: File[], loanId: number, borrowerId: number) {
    const formData = new FormData();
    files.forEach(file => formData.append('files', file));
    formData.append('loanId', String(loanId));
    formData.append('borrowerId', String(borrowerId));
    return this.post(url.UPLOAD_BANK_STATEMENTS, formData);
  }

  downloadBankStatement(bankStatementRecordId: number) {
    return this.get(url.DOWNLOAD_BANK_STATEMENT, { bankStatementRecordId }, { responseType: 'arraybuffer' });
  }

  saveOtherSource(otherSource: BankStatementOtherSource) {
    return this.post(url.SAVE_OTHER_SOURCE, otherSource);
  }

  deleteOtherSource(bankStatementOtherSourceId: number) {
    return this.delete(url.DELETE_OTHER_SOURCE, {
      otherSourceRecordId: bankStatementOtherSourceId,
    });
  }

}
